import { HealthResponse, SearchResult } from "../schema/schema";

const baseApiUrl = "https://api.rev-we.ordinall.dev";

export async function checkHealth(): Promise<HealthResponse> {
  const res = await fetch(baseApiUrl + "/health");
  if (!res.ok) throw new Error("Health check failed");
  return res.json();
}

export async function searchByFile(file: File, removeNsfw: boolean = true): Promise<SearchResult> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("remove_nsfw", removeNsfw ? "1" : "0");

  const res = await fetch(baseApiUrl + "/search", {
    method: "POST",
    body: formData
  });

  if (!res.ok) throw new Error("Search failed");
  return res.json();
}

export async function searchByUrl(imageUrl: string, removeNsfw: boolean = true): Promise<SearchResult> {
  const formData = new FormData();
  formData.append("image_url", imageUrl);
  formData.append("remove_nsfw", removeNsfw ? "1" : "0");

  const res = await fetch(baseApiUrl + "/search", {
    method: "POST",
    body: formData
  });

  if (!res.ok) throw new Error("Search failed");
  return res.json();
}